import LinkToStripeButton from "../../../common/LinkToStripeButton";

const LinkSolutionToStripeButton = ({
  linkToStripe,
}: {
  linkToStripe: {
    link: () => void;
    loading: boolean;
  };
}) => {
  return (
    <LinkToStripeButton
      handleClick={() => linkToStripe.link()}
      loading={linkToStripe.loading}
    />
  );
};

export default LinkSolutionToStripeButton;
